/**
 * 漫画项目
 */

import BaseAuthClient from './baseAuth';

class ComicClient extends BaseAuthClient {
  constructor() {
    super({
      baseURL: '/api'
    });
  }
}

const comicClient = new ComicClient();

export default comicClient;

// 漫画项目列表(画手工作台)
export const getComicList = (option: any) => comicClient.get(`/v1/workbench/projects`, option);

// 漫画项目列表(项目管理)
export const getProjectByStatus = (option: any) => comicClient.get(`/v1/project/getprojectbystatus`, option);

// 查看成员参与项目
export const userProlist = (option: any) => comicClient.get(`/v1/project/userprolist`, option);

// 新增漫画项目
export const createComic = (option: any) => comicClient.post(`/v1/project/addproject`, option);

// 添加项目的环节流程模板
export const addProjectlink = (option: any) => comicClient.post(`/v1/project/addproject`, option);

// 更新漫画项目
export const updateComic = (option: any) => comicClient.put(`/v1/project/editproject`, option);

// 项目管理获取分状态的项目数量
export const getProjectNum = (option: any) => comicClient.get(`/v1/project/getprojectnum`, option);

// 获取流程设置的模板
export const getTemplate = (option: any) => comicClient.get(`/v1/link/gettemplate`, option);

// 获取项目详情
export const getProjectDetail = (option: any) => comicClient.get(`/v1/project/getprojectdetail`, option);

// 获取项目详情
export const searchCreateUser = (option: any) => comicClient.get(`/v1/project/searchcreateuser`, option);

// 删除项目
export const delProject = (option: any) => comicClient.delete(`/v1/project/delproject`, option);

// 恢复项目
export const recoverProject = (option: any) => comicClient.post(`/v1/project/recover`, option);

// 根据关键词获取漫画项目列表(模糊搜索)
export const getProjectListByName = (option: any) => comicClient.get(`/v1/project/getprojectbyname`, option);

// 添加默认环节
export const addTemplateLink = (option: any) => comicClient.post(`/v1/link/addtemplatelink`, option);

// 删除默认环节
export const delTemplateLink = (option: any) => comicClient.post(`/v1/link/deltemplatelink`, option);

// 排序环节
export const sortTemplateLink = (option: any) => comicClient.put(`/v1/link/sorttemplatelink`, option);

// 任务组-重置环节
export const refreshStep = (option: any) => comicClient.put(`/v1/processinstances/refresh`, option)
.then((res: any) => res.raw.data);

